import React from "react";
import {
  CheckCircle,
  AlertCircle,
  Info,
} from "lucide-react";
import { NotificationType } from "./notificationMockData";

export const notificationIconMap: Record<
  NotificationType,
  { icon: React.ReactNode; color: string }
> = {
  property_added: {
    icon: <CheckCircle size={20} color="#16a34a" />, // Green
    color: "#dcfce7",
  },
  approval_needed: {
    icon: <AlertCircle size={20} color="#ea580c" />, // Orange
    color: "#ffedd5",
  },
  attribute_missing: {
    icon: <AlertCircle size={20} color="#ea580c" />, // Orange
    color: "#ffedd5",
  },
  brand_verified: {
    icon: <Info size={20} color="#155dfc" />, // Blue
    color: "#dbeafe",
  },
  dynamic_cost: {
    icon: <CheckCircle size={20} color="#16a34a" />, // Green
    color: "#dcfce7",
  },
  new_team_member: {
    icon: <Info size={20} color="#155dfc" />, // Blue
    color: "#dbeafe",
  },
  document_expiring: {
    icon: <AlertCircle size={20} color="#ea580c" />, // Orange
    color: "#ffedd5",
  },
  payment_received: {
    icon: <CheckCircle size={20} color="#16a34a" />, // Green
    color: "#dcfce7",
  },
};
